<template>
  <div>
    <div v-if="singleLayerToggle">
      <v-list dense expand
              :color="color"
              v-if="LAYERS"
              :class="float ? 'lc-floating' : ''"
              style="z-index: 15; position: absolute; overflow-x: hidden"
              :style="{top: `${yOffset}px`, left: `${xOffset}px`, width: float ? '280px' : '100%', maxHeight: getHeight(), overflowY: 'auto'}">
        <layer-control-layer text-color="primary"
                             :layer="LAYERS[0].layers[0]"></layer-control-layer>
      </v-list>
    </div>
    <div v-else class="lc-container"
         :style="getStyle">
      <layer-control-toggle v-if="float" :show.sync="showLC" :class="showLC ? '' : 'minimised'"></layer-control-toggle>
      <v-list dense expand
              :color="color"
              v-if="showLC && LAYERS"
              :class="float ? 'lc-floating' : ''"
              style="z-index: 15; overflow-x: hidden;"
      >
        <v-list-group
          v-for="(collection, col) in LAYERS"
          color="primary"
          :key="col"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="h6 font-weight-bold text-wrap text--primary"
                                 v-text="collection.title"></v-list-item-title>
            </v-list-item-content>
          </template>

          <div v-for="(layer, lay) in collection.layers"
               :key="lay">
            <layer-control-layer text-color="primary"
                                 :layer="layer"></layer-control-layer>
            <layer-legend
              :layer="layer"
              v-if="CONFIG.config.legend && active.indexOf(layer.layerid) > -1 && layer.ows_source !== 'external'"></layer-legend>
          </div>
        </v-list-group>
      </v-list>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import LayerLegend from './LayerLegend';
import color from '@/mixins/color';
import LayerControlLayer from './LayerControlLayer';
import LayerControlToggle from '@/components/SideBar/LayerControlToggle.vue';

export default {
  name: 'LayerControl',
  components: {
    LayerControlToggle,
    LayerControlLayer,
    LayerLegend
  },
  mixins: [color],
  props: {
    color: {
      type: String,
      default: ''
    },
    float: {
      type: Boolean,
      default: false,
    },
    yOffset: {
      type: Number,
      default: 0
    },
    xOffset: {
      type: Number,
      default: 0
    }
  },

  methods: {
    toggleLayerControl() {
      this.showLC = !this.showLC;
    },
    getHeight() {
      if (!this.float) {
        return `calc(100% - ${this.yOffset}px)`;
      } else {
        let footerOffset = 0;

        if (this.CONFIG.config.footer) {
          footerOffset = 25;
        }
        return document.body.offsetHeight - footerOffset - 150 + 'px !important';
      }
    },
  },

  computed: {
    ...mapGetters('layers', {
      LAYERS: 'LAYERCONTROL_DATA',
      LEGEND: 'LEGEND',
    }),
    ...mapGetters(['CONFIG']),
    ...mapState('layers', ['active']),
    singleLayerToggle() {

      return this.LAYERS.length === 1 && this.LAYERS[0].layers.length === 1;
    },
    getStyle() {
      return {
        position: 'absolute',
        top: `${this.yOffset}px`,
        left: `${this.xOffset}px`,
        width: this.float ? '25%' : '100%',
        minWidth: '300px',
        maxWidth: (() => {
          if (this.float) {
            if (this.$vuetify.breakpoint.mobile) {
              return '90%';
            } else {
              return '400px';
            }
          } else {
            return '100%';
          }
        })(),
        maxHeight: `calc(100vh - ${this.yOffset + 100}px)`,
        zIndex: 15,
      };
    },
  },

  data() {
    return {
      showLC: true,
      hover: false,
    };
  },

  mounted() {
    this.showLC = !this.$vuetify.breakpoint.mobile;
  },
};
</script>

<style lang="scss" scoped>
.lc-floating-bar {
  background-color: #263746;
  opacity: 0.9;
  height: 20px;
  overflow: hidden;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;

  &.minimised {
    border-radius: 6px;
  }
}

.lc-container {
  &:hover {
    .lc-floating, .lc-floating-bar {
      opacity: 1;
    }
  }
}

.lc-floating {
  opacity: 0.9;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  padding-top: 0px;
  padding-bottom: 0px;
  border: 1px solid #263746 !important;
  overflow-y: auto;
  position: absolute;
  max-height: calc(100vh - 180px);
  max-width: 90vw;
  background-color: white;

  .v-list-item__action {
    margin: 0 0 0 0 !important;
  }

  .v-btn--fab.v-size--x-small {
    height: 24px;
    width: 24px;
  }
}
</style>
